import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import BrandModalContent from "./ModalContent/BrandModalContent";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import {useGetBrnadList,} from "./ModalContent/useBrandRepo";
import { useGetOrgUnitsData } from "../Employee/hooks/useEmployee";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";


const Brands = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<any>(null);

  const [filter,setFilter] = useState({
    start: 0,
    length: 20,
    orgUnitId:null,
    search: '',
  })
  
  const [disable,setDisabled] = useState<boolean>(false);
  
  // API
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  // console.log('orgUnitsList for Brand',orgUnitsList?.data) 

  const { data, isLoading, isSuccess } = useGetBrnadList({
    enable: true,
    params: {
      start: filter.start,
      length: filter.length,
      Orgunitid: filter.orgUnitId,
      search: filter.search,
    },
  });
  
// console.log('Brand data---->',data?.data?.recordsTotal);
 
const BrandTableData = data?.data?.data?.map((item:any)=>({
  Orgunitid:item?.Orgunitid || '',
  orgunit: item?.UnitName ||'',
  brandname:item?.BrandName || '',
  brandcode:item?.BrandCode || '',
  brandrate:item?.BrandRate || '',
  minvalue: item?.MinValue || '',
  created: item?.CreatedAt|| '',
  modified: item?.UpdatedAt == null ? '-' : item?.UpdatedAt,
  BrandId: item?.BrandId || null,
}))

// console.log('BrandTableData--->',BrandTableData)   

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) setSelectedBrand(null); // Reset selected brand when closing
  };

  const handleEditClick = (brand: any) => {
    setSelectedBrand(brand); // Set existing brand data
    setIsModalOpen(true); // Open modal
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedBrand(null);
  };

  const handleSelection = (selected: string) => {
    console.log("Selected:", selected);
  };

 const handleChangeRowPerPage=(limit:any,pageNo:any)=>{
           setFilter((prev:any)=>({
            ...prev,
            start:pageNo,
            length:limit
           }))
  }

  const handlePagination=(pageNo:number)=>{
    setFilter((prev:any)=>({
       ...prev,
         start:pageNo
    }))
  }
 
  const brandDataColumns = [
    { name: "Org Unit", selector: (row: any) => row.orgunit, sortable: true ,width:'150px'},
    {
      name: "Brand Name",
      selector: (row: any) => row.brandname ||'-',
      sortable: true,
      wrap:true,
      width:'150px'
    },
    {
      name: "Brand Code",
      selector: (row: any) => row.brandcode ||'-',
      sortable: true,
      width:'150px'
    },
    {
      name: "Brand Rate",
      selector: (row: any) => row.brandrate ||'-',
      sortable: true,
      width:'150px'
    },
    { name: "Min Value", selector: (row: any) => row.minvalue, sortable: true ,width:'130px'},
    { 
      name: "Created At", 
      selector: (row: any) => row.created ||'-',
      sortable: true,
      wrap:true,
      
    },
    {
      name: "Modified At",
      selector: (row: any) => row.modified ||'-',
      sortable: true,
       wrap:true ,
    },
    {
      name: "Action",
      cell: (row: any) => (
        <button
          onClick={() => handleEditClick(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  const filterOptions = [
    {
      label: "Organization",
      options: [
        { id: "All", label: "All" },
        { id: "HR", label: "HR" },
        { id: "Finance", label: "Finance" },
        { id: "IT", label: "IT" },
      ],
    },
    {
      label: "Brand",
      options: [
        { id: "All", label: "All" },
        { id: "HR", label: "HR" },
        { id: "Finance", label: "Finance" },
        { id: "IT", label: "IT" },
      ],
    },
  ];
  
  const handleDownLoad = async(fileTye:string)=>{
      const appToken  = localStorage.getItem('Apptoken')||'';
      const params:Record<string,any>={
        ...(filter.orgUnitId === null?{}:{Orgunitid:filter.orgUnitId}),
        ...(filter.search ===''?{}:{search:filter.search})
      }
      const querystring = new URLSearchParams(params).toString();
      const apiEndpoint = `${BASE_URL}admin/api/getBrandsExcel?${querystring}`;
      const fileName = 'Brand.xlsx';

      try{
        setDisabled(true);
        const response = await downloadExcelGet({apiEndpoint,appToken,fileName})     
        if(response.success){
            setDisabled(false);
        }      
      }catch(error:any){
        console.log('Error while downloading Brand excel');
      }finally{
        setDisabled(false);
      }
  }

  return (
    <div className="p-2">
      <PageHeader
        title="Brands"
        buttons={[
          {
            label: "+ Add Brands",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => handleDownLoad("Excel"),
            color:disable?"#888":"#43B9B2",
            disable:disable
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Brand list"
        dynamicHeightOnRowsPerPage={true}
        data={!isLoading && isSuccess && BrandTableData || []}
        columns={brandDataColumns}
        filterOptions={filterOptions}
        showSpinner={isLoading}
        search={true}
        handleSearch={(e:any)=>setFilter((prev:any)=>({
          ...prev,
          search:e
        }))}

        paginationTotalRows={!isLoading && isSuccess && data?.data?.recordsTotal}
        onChangeRowsPerPage={(limit:any,pageNo:any)=>{
          handleChangeRowPerPage(limit,pageNo)
        }}
        onChangePage={(pageNo:number)=>{
           handlePagination(pageNo);
        }}
        headerContent={
        <div style={{marginRight:10}}>  
        <RoundedDropdown
        options={(orgUnitsList?.data) || []}
        // onSelect={(e) => handleFilter(props.handleFilterObjectKey, e)}
        onSelect={(value:any) =>setFilter((prev:any)=>({
            ...prev,
            orgUnitId:value.id
        }))}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading='Org Unit'
        headingColor="#2e8dd3"
      />
     </div>
        }

      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={selectedBrand ? "Edit Brand" : "Add Brand"}
        size="md"
        content={
          <BrandModalContent
            selectedBrand={
              selectedBrand || {
                brandname: "",
                brandcode: "",
                brandrate: "",
                minvalue: "",
                orgunit:'',
                BrandId:'',
                Orgunitid:''
              }
            }
            setSelectedBrand={setSelectedBrand}
            handleClose={toggleModal}
          />
        }
      />
    </div>
  );
};

export default Brands;
